import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-down",
  "use": "chevron-down-usage",
  "viewBox": "0 0 404.308 404.309",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 404.308 404.309\" id=\"chevron-down\"><path d=\"M0 101.08h404.308L202.151 303.229 0 101.08z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol